import { FormSectionHandler } from '../entity.handler';
import { SmsGatewayProviderResponse, SmsGatewayProviderUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { EntityUtils } from '../utils';

interface EditorValues {
    [key: string]: string;
}

export class SmsGatewayParametersSectionHandler implements FormSectionHandler<SmsGatewayProviderResponse, EditorValues> {

    type = 'form';
    icon = 'wrench';
    bulk = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        public creating: boolean
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.SMSGATEWAYPROVIDER.PARAMETERS.${key}`, values);
    }

    applyUpdate(entity: SmsGatewayProviderResponse, payload: SmsGatewayProviderUpdateRequest): Promise<SmsGatewayProviderResponse> {
        return this.admin.applyUpdate(api => api.entities.updateSmsGatewayProvider(entity.id, payload));
    }

    async mapEntityToEditor(entity: SmsGatewayProviderResponse): Promise<EditorValues> {
        return entity.parameters || {};
    }

    mapEditorToEntity(entity: SmsGatewayProviderUpdateRequest, values: EditorValues): Promise<SmsGatewayProviderUpdateRequest> {
        const patch: SmsGatewayProviderUpdateRequest = {
            parameters: values,
        };
        return Promise.resolve(EntityUtils.mergeFields(['parameters'], patch, entity));
    }

    async getFields(entity: SmsGatewayProviderResponse): Promise<FormBuilderField[]> {

        if (entity.type) {
            const smsGatewayProviderType = await this.admin.getCached(`getSmsGatewayProviderType/${entity.type.id}`, api => api.entities.getSmsGatewayProviderType(entity.type.id));
            const params = JSON.parse(smsGatewayProviderType.parameterDefinition);
            const fields: FormBuilderField[] = [];
            params.groups.forEach(group => {
                group.fields.forEach(field => {
                    fields.push(field);
                });
            });
            return EntityUtils.prepareBulk(!entity, [], fields);
        } else {
            return [];
        }

    }

}
